import React, { useState } from 'react';
import Header from "../Components/Header";
import Footer from "./Footer";
import './Internship.css'
import {
    Box,
    Typography,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    FormControl,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    Radio,
    Checkbox,
    FormGroup,
    Select,
    MenuItem,
    IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import internshipChart from '../images/internship1.webp';
import machinedata from '../images/machinedata.jpeg'
import webdesigndata from '../images/webcardimage.jpeg'
import cloudcarddata from '../images/cloudimgfile.jpeg'
import networkcarddata from '../images/automation.jpeg'
import sqlcard from '../images/sqlcard.jpeg'
import datacard from '../images/datacard.jpeg'
import mobilecard from '../images/mobilecard.jpeg'
import dataanalytic from '../images/dataanalytic.jpeg'
import serviceimg1 from '../images/about1.jpeg';



const InternshipForm = ({
    open,
    handleClose,
    handleDateChange,
    handleGenderChange,
    handleDayChange,
    handleChange,
    handleSubmit,
    gender,
    availableDays,
    dob,
    selectedValue,
    formData,
    setFormData,
    errors,
    loading
}) => (
    <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title" className="dialog-title">Internship Registration
        <IconButton
                edge="end"
                color="inherit"
                onClick={handleClose}
                aria-label="close"
                style={{ position: 'absolute', right: 8, top: 8 }}
            >
                <CloseIcon />
            </IconButton></DialogTitle>

        <DialogContent className="dialog-content">
            <form noValidate autoComplete="off" onSubmit={handleSubmit}>
                <TextField
                    margin="dense"
                    label="First Name"
                    variant="outlined"
                    fullWidth
                    required
                    value={formData.firstName}
                    onChange={(e) => setFormData({ ...formData, firstName: e.target.value })}
                    error={!!errors.firstName}
                    helperText={errors.firstName}
                />
                <TextField
                    margin="dense"
                    label="Last Name"
                    variant="outlined"
                    fullWidth
                    required
                    value={formData.lastName}
                    onChange={(e) => setFormData({ ...formData, lastName: e.target.value })}
                    error={!!errors.lastName}
                    helperText={errors.lastName}
                /><br/><br/>
                <TextField
    label="Date of Birth"
    value={dob}
    type="date"
    onChange={handleDateChange}
    fullWidth
    InputLabelProps={{ shrink: true }}
    error={!!errors.dob}
    helperText={errors.dob}
/>
                <TextField
                    margin="dense"
                    label="Email"
                    variant="outlined"
                    fullWidth
                    required
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    error={!!errors.email}
                    helperText={errors.email}
                />
                <TextField
                    margin="dense"
                    label="Phone Number"
                    variant="outlined"
                    fullWidth
                    required
                    value={formData.phoneNumber}
                    onChange={(e) => setFormData({ ...formData, phoneNumber: e.target.value })}
                    error={!!errors.phoneNumber}
                    helperText={errors.phoneNumber}
                />
                <FormControl margin="dense" fullWidth className="form-control" error={!!errors.gender}>
    <FormLabel className="form-control-label">Gender</FormLabel>
    <RadioGroup row value={gender} onChange={handleGenderChange}>
        <FormControlLabel value="female" control={<Radio />} label="Female" />
        <FormControlLabel value="male" control={<Radio />} label="Male" />
        <FormControlLabel value="other" control={<Radio />} label="Other" />
    </RadioGroup>
    {errors.gender && <Typography color="error">{errors.gender}</Typography>}
</FormControl>
                <TextField
                    margin="dense"
                    label="College Name"
                    variant="outlined"
                    fullWidth
                    required
                    value={formData.collegeName}
                    onChange={(e) => setFormData({ ...formData, collegeName: e.target.value })}
                    error={!!errors.collegeName}
                    helperText={errors.collegeName}
                />
                <TextField
                    margin="dense"
                    label="College Details"
                    variant="outlined"
                    fullWidth
                    required
                    value={formData.collegeDetails}
                    onChange={(e) => setFormData({ ...formData, collegeDetails: e.target.value })}
                    error={!!errors.collegeDetails}
                    helperText={errors.collegeDetails}
                />
                <TextField
                    margin="dense"
                    label="Internship Program (Subjects)"
                    variant="outlined"
                    fullWidth
                    required
                    value={formData.programSubjects}
                    onChange={(e) => setFormData({ ...formData, programSubjects: e.target.value })}
                    error={!!errors.programSubjects}
                    helperText={errors.programSubjects}
                />
                <FormControl margin="dense" fullWidth className="form-control" error={!!errors.selectedValue}>
    <Select
        labelId="internship-duration-label"
        id="internship-duration"
        className="select-menu"
        value={selectedValue}
        onChange={handleChange}
        displayEmpty
    >
        <MenuItem disabled value="">
            <em>Internship Duration</em>
        </MenuItem>
        <MenuItem value="15 days">15 Days</MenuItem>
        <MenuItem value="1 month">1 Month</MenuItem>
        <MenuItem value="2 months">2 Months</MenuItem>
        <MenuItem value="3 months">3 Months</MenuItem>
        <MenuItem value="6 months">6 Months</MenuItem>
    </Select>
    {errors.selectedValue && <Typography color="error">{errors.selectedValue}</Typography>}
</FormControl>

                <FormControl margin="dense" fullWidth className="form-control">
                    <FormLabel className="form-control-label">Available Days</FormLabel>
                    <FormGroup row>
                        {["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"].map((day) => (
                            <FormControlLabel
                                key={day}
                                control={<Checkbox checked={availableDays[day]} onChange={handleDayChange} name={day} />}
                                label={day.charAt(0).toUpperCase() + day.slice(1)}
                            />
                        ))}
                    </FormGroup>
                </FormControl>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cancel
                    </Button>
                    <Button type="submit" color="primary" disabled={loading}>
                        {loading ? 'Submitting...' : 'Submit'}
                    </Button>
                </DialogActions>
            </form>
        </DialogContent>
    </Dialog>
);

const Internship = () => {
    const [open, setOpen] = useState(false);
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        collegeName: '',
        collegeDetails: '',
        programSubjects: '',
        mailAddress: '',
    });
    const [gender, setGender] = useState('');
    const [availableDays, setAvailableDays] = useState({
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
        sunday: false,
    });
    const [dob, setDob] = useState('');
    const [selectedValue, setSelectedValue] = useState('');
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false); // Added state for tracking submission status
    const [successDialogOpen, setSuccessDialogOpen] = useState(false);

    const handleChange = (event) => {
        setSelectedValue(event.target.value);
    };

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleGenderChange = (event) => {
        setGender(event.target.value);
    };

    const handleDayChange = (event) => {
        setAvailableDays({
            ...availableDays,
            [event.target.name]: event.target.checked,
        });
    };

    const handleDateChange = (event) => {
        setDob(event.target.value);
    };

    const handleSuccessDialogClose = () => {
        setSuccessDialogOpen(false);
    };

    // Component for the Success Dialog
    const SuccessDialog = ({ open, handleClose }) => (
        <Dialog open={open} onClose={handleClose} aria-labelledby="success-dialog-title">
            {/* <DialogTitle id="success-dialog-title">Success</DialogTitle> */}
            <DialogContent>
                <Typography>Thanks for applying! We'll review your application shortly.</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );

    const validate = () => {
        const newErrors = {};
        if (!formData.firstName) newErrors.firstName = 'First Name is required';
        if (!formData.lastName) newErrors.lastName = 'Last Name is required';
        if (!formData.email) newErrors.email = 'Email is required';
        if (!formData.phoneNumber) newErrors.phoneNumber = 'Phone Number is required';
        if (!formData.collegeName) newErrors.collegeName = 'College Name is required';
        if (!formData.collegeDetails) newErrors.collegeDetails = 'College Details are required';
        if (!formData.programSubjects) newErrors.programSubjects = 'Internship Program (Subjects) is required';
        if (!gender) newErrors.gender = 'Gender is required';
        if (!dob) newErrors.dob = 'Date of Birth is required';
        if (!selectedValue) newErrors.selectedValue = 'Internship Duration is required';
        return newErrors;
      };
      


    const handleSubmit = async (event) => {
        event.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        setLoading(true);
        try {
            const response = await fetch('https://globalsgtech.com/api/api/internship-form', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    ...formData,
                    gender,
                    dob,
                    internshipDuration: selectedValue,
                    availableDays,
                }),
            });

            if (!response.ok) {
                const errorData = await response.text(); // Get response body for error details
                throw new Error(`Network response was not ok: ${response.status} ${response.statusText}. Details: ${errorData}`);
            }
            setSubmitted(true);
            setSuccessDialogOpen(true);
            handleClose();
            setFormData({
                firstName: '',
                lastName: '',
                email: '',
                phoneNumber: '',
                collegeName: '',
                collegeDetails: '',
                programSubjects: '',
                mailAddress: '',
            });
        } catch (error) {
            console.error('Error:', error.message);
        } finally {
            setLoading(false);
        }
    };



    const renderProgramHighlights = () => (
        <>
            <Typography variant="h5" className="program-highlights-title">Program Highlights:</Typography>
            <ul className="program-highlights-list">
                <li><strong>Internship Durations:</strong> 6 days to 6 months based on student performance</li>
                <li><strong>Training Hours:</strong> 3 hours per day</li>
                <li><strong>Software and Tools:</strong> Guidance on installation provided</li>
                <li><strong>Internship Report:</strong> Assistance with report creation</li>
                <li>
                <strong>100% Practical Classes:</strong> Our internship is designed for hands-on, practical experience, ensuring you gain directly applicable skills.
            </li>
            <li>
                <strong>Syllabus:</strong> The comprehensive syllabus covers essential aspects of your chosen tech field, preparing you for a successful career.
            </li>
                <li><strong>Certificates:</strong> 'Internship Certificate' and 'In-Plant Training Certificate'</li>
                <li><strong>Global SG Tech:</strong> Recognized as a leading internship provider in Chennai for college students and job-seeking professionals. After 6 months of regular paid internship, it becomes free. The best interns may also receive job offers.</li>
            </ul>
        </>
    );

    const renderDetailsTable = () => (
        <><div className="internship-container">
                <section className="internship-programs">
                    <h2>Internship Opportunities for All Students, Graduates, Freshers, and Working Professionals</h2>
                    <div className="program-cards">
                        <div className="program-card">
                            <h3>Machine Learning</h3>
                    <img src={machinedata}  style={{width:'300px',height:'150px'}} alt='Cloud Solutions' />
                    </div>
                        <div className="program-card">
                        <h3>Web Designing</h3>
                        <img src={webdesigndata} style={{width:'300px',height:'150px'}} alt='Cloud Solutions' />
                        </div>
                        <div className="program-card">
                        <h3>Cloud Computing</h3>
                        <img src={cloudcarddata} style={{width:'300px',height:'150px'}} alt='Cloud Solutions' />
                        </div>
                        <div className="program-card">
                        <h3>Networking Automation</h3>
                        <img src={networkcarddata} style={{width:'300px',height:'150px'}} alt='Cloud Solutions' />
                        </div>
                        <div className="program-card">
                        <h3>MySQL</h3>
                        <img src={sqlcard} style={{width:'300px',height:'150px'}} alt='Cloud Solutions' />
                        </div>
                        <div className="program-card">
                        <h3>Mobile Development</h3>
                        <img src={mobilecard} style={{width:'300px',height:'150px'}} alt='Cloud Solutions' />
                        </div>
                        <div className="program-card">
                        <h3>Data Engineering</h3>
                        <img src={datacard} style={{width:'300px',height:'150px'}} alt='Cloud Solutions' />
                        </div>
                        <div className="program-card">
                        <h3>Data Analysis</h3>
                        <img src={dataanalytic} style={{width:'300px',height:'150px'}} alt='Cloud Solutions' />
                        </div>
                    </div>
                </section>

                <footer className="internship-footer">
                    <h2>Ready to Start Your Journey?</h2>
                    <p>Apply for one of our internships today and take the first step towards a successful career. If you have any questions, feel free to <a href="mailto:info@company.com">contact us</a>.</p>
                </footer>
            </div></>
    );

    return (
        <>
            <Header />
            <div className="hero" style={{ backgroundImage: `url(${serviceimg1})` }}>
            <div className="hero-content">
                    <h1 style={{fontSize:'55px', color:'white',fontWeight:'bold', marginTop:'revert', fontFamily: 'Arial, sans-serif' }}>Internship Programs</h1>
                        {/* Hero content goes here */}
                    </div>
                </div>
            <div className="hero-text">
                <h2 variant="body1" className="hero-body">
                    We are dedicated to driving technological advancements and shaping future tech leaders through our immersive internship program.
                </h2>
            </div>
            <div className='intern'>
                <div className='cloudimg'>
                    <img src={internshipChart} alt='Cloud Solutions' />
                </div>
                <div className='cloudcontent'>
                    {renderProgramHighlights()}
                    <div>
                        <Button variant="contained" className="apply-button" onClick={handleClickOpen}>
                            Apply Now
                        </Button>
                    </div>
                    <InternshipForm
                        open={open}
                        handleClose={handleClose}
                        handleDateChange={handleDateChange}
                        handleGenderChange={handleGenderChange}
                        handleDayChange={handleDayChange}
                        handleChange={handleChange}
                        handleSubmit={handleSubmit}
                        gender={gender}
                        availableDays={availableDays}
                        dob={dob}
                        selectedValue={selectedValue}
                        formData={formData}
                        setFormData={setFormData}
                        errors={errors}
                        loading={loading}
                    />
                    <SuccessDialog open={successDialogOpen} handleClose={handleSuccessDialogClose} />
                </div>
            </div>
            {renderDetailsTable()}
            <Footer />
        </>
    );
};

export default Internship;